import { API_URL } from "../constants";
import { API } from "./api.service"

const createNotificationTask = () => {

}
const getNotificationTask = (taskId) => {
    return API?.get(`${API_URL?.DEVICE_MANAGEMENT}/simplifi/v1/notificationmanager/task/${taskId}`, `/notificationmanager/task/${taskId}`).then(async (res) => {
        return await new Promise((resolve, reject) => {
            resolve(res);
        })
    })
}

const cancelNotificationTask = () => {

}


export const notificationService = {
    createNotificationTask,
    getNotificationTask,
    cancelNotificationTask
}